import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';

// Layout
import Sidebar from './components/common/Sidebar';
import Header from './components/common/Header';
import Footer from './components/common/footer';
// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import InventoryDetails from './pages/InventoryDetails';
import Accessories from './pages/Accessories';
import AccessoriesDetails from './pages/AccessoriesDetails';
import Orders from './pages/Orders';
import OrdersDetails from './pages/OrdersDetails';
import Customers from './pages/Customers';
import CustomersDetails from './pages/CustomersDetails';
import Tailors from './pages/Tailors';
import TailorsDetails from './pages/TailorsDetails';
import Assignments from './pages/Assignments';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Suppliers from './pages/Suppliers';
import SuppliersDetails from './pages/SuppliersDetails';
import GeneralSettings from './pages/GeneralSettings';
import ViewAssignment from './pages/viewAssignment';
import TailorHistory from './pages/Tailor-history';

import './styles/globals.css';

function AppLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const m = window.matchMedia('(max-width: 768px)');
    setSidebarOpen(!m.matches);
    const onResize = () => setSidebarOpen(!(window.innerWidth <= 768));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div className="app-layout">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="main-content">
        <Header onSidebarToggle={() => setSidebarOpen((s) => !s)} />
        {children}
        <Footer />
      </div>
    </div>
  );
}

function PrivatePage({ component: Component, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <AppLayout>
        <Component />
      </AppLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#1e293b',
              color: '#f0f6ff',
              border: '1px solid #2a3a54',
              borderRadius: 10,
              fontFamily: 'Sora, sans-serif',
              fontSize: '0.875rem',
            },
            success: { iconTheme: { primary: '#10b981', secondary: '#1e293b' } },
            error: { iconTheme: { primary: '#ef4444', secondary: '#1e293b' } },
          }}
        />

        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={<PrivatePage component={Dashboard} />} />
          <Route path="/inventory" element={<PrivatePage component={Inventory} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/inventory/:id" element={<PrivatePage component={InventoryDetails} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/accessories" element={<PrivatePage component={Accessories} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/accessories/:id" element={<PrivatePage component={AccessoriesDetails} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/orders" element={<PrivatePage component={Orders} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/orders/:id" element={<PrivatePage component={OrdersDetails} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/customers" element={<PrivatePage component={Customers} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/customers/:id" element={<PrivatePage component={CustomersDetails} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/tailors" element={<PrivatePage component={Tailors} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/tailors/:id" element={<PrivatePage component={TailorsDetails} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/assignments" element={<PrivatePage component={Assignments} roles={['tailor', 'admin', 'manager', 'staff']} />} />
          <Route path="/assignments/:id" element={<PrivatePage component={ViewAssignment} roles={['tailor', 'admin', 'manager', 'staff']} />} />
          <Route path="/reports" element={<PrivatePage component={Reports} roles={['admin', 'manager']} />} />
          <Route path="/users" element={<PrivatePage component={Users} roles={['admin']} />} />
          <Route path="/suppliers" element={<PrivatePage component={Suppliers} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/suppliers/:id" element={<PrivatePage component={SuppliersDetails} roles={['admin', 'manager', 'staff']} />} />
          <Route path="/settings" element={<PrivatePage component={GeneralSettings} roles={['admin']} />} />
          <Route path="/tailor-history" element={<PrivatePage component={TailorHistory} roles={['admin', 'manager', 'staff']} />} />

          {/* <Route path="/category" element={<PrivatePage component={Category} roles={['admin']} />} /> */}
          
          <Route path="/unauthorized" element={
            <div className="loading-screen">
              <div style={{ fontSize: '3rem' }}>🚫</div>
              <h2>Access Denied</h2>
              <p className="text-muted">You don't have permission to view this page</p>
              <a href="/" className="btn btn-primary">Go to Dashboard</a>
            </div>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
